












import { Vue, Component } from 'vue-property-decorator'
import AboCard from '~components/subscribers/AboCard.vue'

@Component({
  components: {
    AboCard,
  },
})
export default class AbocardWidget extends Vue {
  mounted() {
    this.$store.dispatch('paywall/fetchAboNo')
  }

  showLogin() {
    this.$store.dispatch('paywall/showLoginOverlay', {
      showCloseButton: true,
    })
  }

  showRegistration() {
    this.$store.dispatch('paywall/showRegistrationOverlay', {
      showCloseButton: true,
    })
  }

  getCard() {
    window.open(
      `/vorteilsclub/v1/pkpass?userRef=${this.$store.getters['paywall/getUserRef']}`,
      '_blank'
    )
  }
}
